"use strict";

function registerStateSource(marty, id, stateSourceId, clazz) {
  marty[id] = clazz;
  marty.stateSources[stateSourceId] = clazz;
}

module.exports = registerStateSource;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/registerStateSource.js
// module id = SLef
// module chunks = 88